<template>
  <el-carousel :interval="3000" type="card" height="535.4px" width="265px" indicator-position="none">
    <el-carousel-item v-for="(item, idx) in bigBossList" :key="idx">
      <div class="image">
        <img :src="item" />
      </div>
    </el-carousel-item>
  </el-carousel>
</template>

<script>
import bigBoss1 from "@/assets/img/jinju-2024/bigboss/1.png";
import bigBoss2 from "@/assets/img/jinju-2024/bigboss/2.png";
import bigBoss3 from "@/assets/img/jinju-2024/bigboss/3.png";
import bigBoss4 from "@/assets/img/jinju-2024/bigboss/4.png";
import bigBoss5 from "@/assets/img/jinju-2024/bigboss/5.png";
import bigBoss6 from "@/assets/img/jinju-2024/bigboss/6.png";
import bigBoss7 from "@/assets/img/jinju-2024/bigboss/7.png";
import bigBoss8 from "@/assets/img/jinju-2024/bigboss/8.png";
import bigBoss9 from "@/assets/img/jinju-2024/bigboss/9.png";
import bigBoss10 from "@/assets/img/jinju-2024/bigboss/10.png";

export default {
  data() {
    return {
      bigBossList: [
        bigBoss1,
        bigBoss2,
        bigBoss3,
        bigBoss4,
        bigBoss5,
        bigBoss6,
        bigBoss7,
        bigBoss8,
        bigBoss9,
        bigBoss10
      ],
    }
  },

}
</script>

<style lang="scss" scoped>
.image {
  width: fit-content;
  margin: 0 auto;
  height: 534px;
}
</style>

<!-- <style>
    .el-carousel__item h3 {
      color: #475669;
      font-size: 14px;
      opacity: 0.75;
      line-height: 200px;
      margin: 0;
    }
    
    .el-carousel__item:nth-child(2n) {
      background-color: #99a9bf;
    }
    
    .el-carousel__item:nth-child(2n+1) {
      background-color: #d3dce6;
    }
  </style> -->